<script>
    import {store} from '../../stores.js';

    export let add_item;
    export let id;
    export let errors;
    
    const axis = store('axis', '', false);
</script>

<button type="button" class="btn btn-primary btn-block btn-lg" disabled={errors} on:click={add_item}>
    {#if !errors}
        {#if !$axis}
            {id ? 'Обновить' : 'В заказ'}
        {:else}
            {id ? 'Сохранить' : 'Добавить'}
        {/if}
    {:else}
        Некорректные данные
    {/if}
</button>
